import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {UserLink} from 'src/components/links';

import {
    userSearchResultAuditDataSelector,
    userSearchResultAuditResultSelector,
} from '../../slices/user-search-result-audit.slice';

type Props = {
    userId: number,
    place: string,
};

export const ModifierCell = ({userId, place}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAuditDataSelector);
    const result = useSelector(userSearchResultAuditResultSelector);

    const modifierInfo = useMemo(
        () => result?.data[userId]?.lastUpdated.modifierInfo,
        [result, userId],
    );

    if (isLoading || loadingError || !modifierInfo) {
        return null;
    }

    return (
        <UserLink
            userId={modifierInfo.userId}
            caption={[
                modifierInfo.userFirstName,
                modifierInfo.userLastName,
            ].filter(Boolean).join(' ') || modifierInfo.userId?.toString()}
            place={place}
        />
    );
};
